// 装修
export const DECORATION = [
  {
    title: '主题模板',
    img: 'https://qnm.hunliji.com/o_1cvn2surk1udo1lfsj8g1qa3l4fh.png',
    link: '#/localMerchant/marketingCenter/detail/76',
    key: 'no_pro_decoration_dedail_76'
  },
  {
    title: '推荐橱窗',
    img: 'https://qnm.hunliji.com/o_1cvn2surkg306ma1euk1odp1egsg.png',
    link: '#/localMerchant/marketingCenter/detail/75',
    key: 'no_pro_decoration_dedail_75'
  },
  {
    title: '套餐热标',
    img: 'https://qnm.hunliji.com/o_1cvn2surk1u8b1uia2mi1p0112rmf.png',
    link: '#/localMerchant/marketingCenter/detail/70',
    key: 'no_pro_decoration_dedail_70'
  },
  {
    title: '商家承诺',
    img: 'https://qnm.hunliji.com/o_1cvn2surkhs6eq256n1ihbla9e.png',
    link: '#/localMerchant/marketingCenter/detail/72',
    key: 'no_pro_decoration_dedail_72'
  },
  {
    title: '咨询礼',
    img: 'https://qnm.hunliji.com/o_1cvn2surkrld9ubddk1m5n1t1ei.png',
    link: '#/localMerchant/marketingCenter/detail/32',
    key: 'no_pro_decoration_dedail_32'
  },
  {
    title: '到店礼',
    img: 'https://qnm.hunliji.com/o_1cvn2surk59q6kf1cavvcn1auj.png',
    link: '#/localMerchant/marketingCenter/detail/73',
    key: 'no_pro_decoration_dedail_73'
  }
]

// 营销
export const MARKETING = [
  {
    title: '轻松聊',
    desc: '主动出击转化意向客户',
    img: 'https://qnm.hunliji.com/o_1cvn8mfl6a1f1ln2gmp16195ulg.png',
    link: '#/localMerchant/marketingCenter/detail/80',
    key: 'no_pro_marketing_dedail_80'
  },
  {
    title: '天眼系统',
    desc: '大数据助你获取潜在客资',
    img: 'https://qnm.hunliji.com/o_1cvn8mfl6oekge01sol1l8n6f4h.png',
    link: '#/localMerchant/marketingCenter/detail/81',
    key: 'no_pro_marketing_dedail_81'
  },
  {
    title: '优惠券',
    desc: '提升订单转化利器',
    img: 'https://qnm.hunliji.com/o_1cvn8mfl613bch021a1r1ta35vqd.png',
    link: '#/localMerchant/marketingCenter/detail/82',
    key: 'no_pro_marketing_dedail_82'
  },
  {
    title: '聚客宝',
    desc: '助你获取平台精准客资',
    img: 'https://qnm.hunliji.com/o_1cvn8mfl61knqnsk1als1a9f1plae.png',
    link: '#/localMerchant/marketingCenter/detail/juke',
    key: 'no_pro_marketing_dedail_juke'
  },
  {
    title: '潜在客资转化',
    desc: '潜在客资批量联系转化',
    img: 'https://qnm.hunliji.com/o_1cvn8mfl61bneo7ed771l5p1ugcf.png',
    link: '#/localMerchant/potentialCustomersIntro',
    key: 'no_pro_marketing_potential_customers'
  }
]

// logo
export const LOGO = [
  'https://qnm.hunliji.com/o_1ckr4ajvn189m1rnm1falobh1llo7.png?imageView2/1/w/43/h/47/format',
  'https://qnm.hunliji.com/o_1ckr4ajvn189m1rnm1falobh1llo7.png?imageView2/1/w/43/h/47/format',
  'https://qnm.hunliji.com/o_1ckr4ajvn189m1rnm1falobh1llo7.png?imageView2/1/w/43/h/47/format',
  'https://qnm.hunliji.com/o_1ckr4ajvn189m1rnm1falobh1llo7.png?imageView2/1/w/43/h/47/format',
  'https://qnm.hunliji.com/o_1ckr4ajvn189m1rnm1falobh1llo7.png?imageView2/1/w/43/h/47/format',
  'https://qnm.hunliji.com/o_1ckr4ajvn189m1rnm1falobh1llo7.png?imageView2/1/w/43/h/47/format'
]

// 其他人在用
export const OTHER_STOR = [
  'http://qnm.hunliji.com/C189D0D861663D06E2F0855435A61892?imageView2/1/w/190/h/190',
  'http://qnm.hunliji.com/C189D0D861663D06E2F0855435A61892?imageView2/1/w/190/h/190',
  'http://qnm.hunliji.com/C189D0D861663D06E2F0855435A61892?imageView2/1/w/190/h/190',
  'http://qnm.hunliji.com/C189D0D861663D06E2F0855435A61892?imageView2/1/w/190/h/190',
  'http://qnm.hunliji.com/C189D0D861663D06E2F0855435A61892?imageView2/1/w/190/h/190',
  'http://qnm.hunliji.com/C189D0D861663D06E2F0855435A61892?imageView2/1/w/190/h/190'
]
